
import moment from 'moment'

import Checkbox from '@mui/material/Checkbox'

import React, { Fragment as F, useContext, useEffect, useState } from 'react'
import Modal from 'react-modal'

import { AppCtx } from '$src/App'
import PeriodsCtx from './PeriodsCtx'
import {
  apiRouter,
  appRouter,
  C,
  logg,
} from '$shared'

/*
 * PeriodsC
**/
const PeriodsC = (props) => {
  const {
    selectedPeriods,        setSelectedPeriods,
  } = props

  const {
    userConfig,
    theme,
  } = useContext(AppCtx)

  const {
    periodsList,
  } = useContext(PeriodsCtx)
  // logg(periodsList, 'periodsList')

  const toggleSelectedPeriod = (which) => {
    // logg(which, 'toggleSelectedPeriod')
    const _copy = { ...selectedPeriods }
    const _next = !_copy[which]
    if (_next) {
      _copy[which] = true
    } else {
      delete _copy[which]
    }
    setSelectedPeriods(_copy) // sets localStorage and state
  }

  return <F>
    <div className='PeriodsC'>

      { periodsList.map((opt, idx) => <div className={`multiselect-checkboxes-item ${opt.relative_s.indexOf('PYE') == -1 ? 'ytd' : 'pye' }`} key={idx} >
        <Checkbox
          checked={ !!selectedPeriods[opt.value] }
          onChange={ () => toggleSelectedPeriod(opt.value) }
        />
        <span className='label-1'>{ opt.relative_s }</span>
        <span className='label-2'>{ moment(opt.date).format(userConfig.dateFormat) }</span>
      </div> )}

    </div>
  </F>
}

/**
 * PeriodsModal
**/
const PeriodsModal = (props) => {
  // logg(props, 'PeriodsModal')

  const {
    loading, setLoading,
  } = useContext(AppCtx)

  const {
    periodsList,
    periodsModalOpen,       setPeriodsModalOpen,
    selectedPeriods,        setSelectedPeriods,
    selectedPeriodsReverse, setSelectedPeriodsReverse,
  } = useContext(PeriodsCtx)
  // logg(useContext(PeriodsCtx), 'PeriodsCtx in PeriodsModal')



  return <Modal
    ariaHideApp={false}
    className="PeriodsModal BaseModal"
    isOpen={periodsModalOpen}
    onRequestClose={ () => setPeriodsModalOpen(false) }
    overlayClassName="PeriodsModalOverlay"
  >
    <div className='header'>
      <h5 >Periods</h5>
      <div className='close' onClick={() => setPeriodsModalOpen(false)}>&times;</div>
    </div>
    <PeriodsC {...{
      selectedPeriods,        setSelectedPeriods,
    }} />
    <div className='C2'>
      <Checkbox
        checked={ !!selectedPeriodsReverse }
        onChange={ () => {
          setSelectedPeriodsReverse(!selectedPeriodsReverse)
        } }
      />
      Report in ascending order
      {/* Reverse the order */}
    </div>
    <div className='C3'>
      <div className='Btn' onClick={() => setPeriodsModalOpen(false)} >Close</div>
    </div>
  </Modal>
}
export default PeriodsModal
export {
  PeriodsC,
}
